
export default function Services() {
  const services = [
    {
      icon: "ri-search-line",
      title: "Patient Lead Generation",
      description: "We identify and connect you with patients actively seeking concierge and DPC services in your area."
    },
    {
      icon: "ri-map-pin-line",
      title: "Geographic Targeting",
      description: "Precise location-based matching to connect you with patients in your service area."
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Income-Based Matching",
      description: "We match patients based on their financial capacity to ensure they can afford your services."
    },
    {
      icon: "ri-stethoscope-line",
      title: "Specialty Alignment",
      description: "Connect with patients seeking specific medical specialties that match your practice focus."
    },
    {
      icon: "ri-user-heart-line",
      title: "Quality Screening",
      description: "All leads are pre-qualified to ensure they're genuinely interested in concierge or DPC care."
    },
    {
      icon: "ri-team-line",
      title: "Strategy Consultation",
      description: "Our team is available to analyze your current patient acquisition strategy and look for opportunities for improvement."
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Lead Generation Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide end-to-end patient acquisition solutions tailored specifically for concierge and direct primary care practices.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
